import React, { useState } from "react";
import { http } from "@/context/AuthContext";
import { Loader2, Megaphone, CheckCircle2 } from "lucide-react";

export default function AdminAnnouncements() {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setSending(true);
    try {
      await http.post("/admin/announcements", { title, body });
      setSent(true);
      setTitle("");
      setBody("");
      setTimeout(() => setSent(false), 4000);
    } finally { setSending(false); }
  }

  return (
    <div data-testid="admin-announcements">
      <h1 className="text-4xl">Announcements</h1>
      <p className="mt-2 text-navy/65">Send a message to every client's portal inbox at once.</p>

      <form onSubmit={handleSubmit} className="card p-7 mt-8 space-y-5" data-testid="announcement-form">
        <div>
          <label className="text-xs uppercase tracking-widest text-navy/60">Title *</label>
          <input
            data-testid="announcement-title"
            type="text" required value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="input-field mt-2" placeholder="e.g. Holiday office hours"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest text-navy/60">Message *</label>
          <textarea
            data-testid="announcement-body"
            required rows={6} value={body}
            onChange={(e) => setBody(e.target.value)}
            className="input-field mt-2 resize-none" placeholder="What do you want all clients to know?"
          />
        </div>
        {sent && (
          <div className="flex items-center gap-2 text-teal text-sm" data-testid="announcement-success">
            <CheckCircle2 className="w-4 h-4" /> Announcement sent to all clients.
          </div>
        )}
        <button type="submit" disabled={sending} data-testid="announcement-submit" className="btn-primary">
          {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Megaphone className="w-4 h-4" /> Send Announcement</>}
        </button>
      </form>
    </div>
  );
}
